<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-center p-2">
            <h3>{{ $t('token.detail.title-label') }}</h3>
        </div>

        <div class="text-left mt-4 card card-pricing text-center">
            <div class="card-body">
                <p class="card-text">
                    {{ $t('token.confirm.success-label')[0] }}<br />
                    {{ $t('token.confirm.success-label')[1] }}
                </p>

                <router-link :to="{ name: 'home' }" class="btn btn-primary pr-5 pl-5 mt-4">
                    {{ $t('token.confirm.home-label') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TokenConfirm',

        data() {
            return {
                
            }
        },

        methods: {
        }
    }
</script>
